"use client";

import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { portfolioReviewFaqs as FAQS } from "@/data/faqs";



export const PRFaq: React.FC = () => {
  return (
    <section className="relative py-16 md:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="gradient-heading text-3xl md:text-5xl font-prociono font-normal leading-tight tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-b border-[#EDE7E1]"
            >
              <AccordionTrigger className="text-left text-[#232227] font-medium text-base md:text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent forceMount className="data-[state=closed]:hidden text-[#5A4F45] text-sm md:text-base leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
